import { render, staticRenderFns } from "./ReturnAccessCodePopup.vue?vue&type=template&id=5317ca48&"
import script from "./ReturnAccessCodePopup.vue?vue&type=script&lang=js&"
export * from "./ReturnAccessCodePopup.vue?vue&type=script&lang=js&"
import style0 from "./ReturnAccessCodePopup.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports